var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCurrencyCircleDollar = function SvgIconCurrencyCircleDollar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 6.75a1 1 0 1 0-2 0v.5h-.125a2.875 2.875 0 1 0 0 5.75h2.25a.875.875 0 1 1 0 1.75H9.75a1 1 0 1 0 0 2H11v.5a1 1 0 1 0 2 0v-.5h.125a2.875 2.875 0 1 0 0-5.75h-2.25a.875.875 0 1 1 0-1.75h3.375a1 1 0 1 0 0-2H13z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12m10-8a8 8 0 1 0 0 16 8 8 0 0 0 0-16",
    clipRule: "evenodd"
  }))));
};
export default SvgIconCurrencyCircleDollar;